import type { ReactNode } from 'react';

export interface Column<T> {
  key: string;
  header: string;
  /** Célula. Devolve nó, não string, para o chip e o botão entrarem aqui. */
  cell: (row: T) => ReactNode;
  /** Alinha à direita — use para a coluna de ações e para números. */
  align?: 'end';
}

/**
 * Tabela com legenda obrigatória.
 *
 * `caption` não é opcional: sem ela, um leitor de tela que navega por tabelas
 * anuncia "tabela com 7 colunas" e nada mais. No front anterior nenhuma das
 * sete tabelas tinha legenda. Quando o título visível já diz o mesmo, passe
 * `captionHidden` — a legenda continua no acessível e some do visual.
 */
export function Table<T>({
  caption, captionHidden = true, columns, rows, rowKey,
}: {
  caption: string;
  captionHidden?: boolean;
  columns: ReadonlyArray<Column<T>>;
  rows: readonly T[];
  rowKey: (row: T) => string;
}) {
  return (
    <div className="table-wrap">
      <table className="table">
        <caption className={captionHidden ? 'sr-only' : undefined}>{caption}</caption>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} scope="col" style={column.align === 'end' ? { textAlign: 'end' } : undefined}>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={rowKey(row)}>
              {columns.map((column) => (
                <td key={column.key}>
                  {column.align === 'end' ? <div className="table__actions">{column.cell(row)}</div> : column.cell(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
